import PropTypes from 'prop-types';

import { TITLE } from './constants';
import { CalculateButton, FormContainer, FormTitle } from './styles';
import Label from '../../ComponentLibrary/input-elements/oc-label';
import TextInput from '../../ComponentLibrary/input-elements/oc-text-input';

const Form = ({ method, themeColor, formInputs, handleInputChange, onCalculate }) => {
  const inputs = formInputs[method] || {};

  return (
    <FormContainer>
      <FormTitle>{TITLE[method]}</FormTitle>
      {Object.entries(inputs).map(([key, input]) => (
        <div key={key}>
          <Label forId={key} text={input.label} required={input.required} />
          <TextInput
            id={key}
            name={key}
            placeholder={input.placeholder}
            value={input.value}
            onChange={handleInputChange}
          />
        </div>
      ))}
      <CalculateButton themeColor={themeColor} onClick={() => onCalculate(method)}>
        Calculate
      </CalculateButton>
    </FormContainer>
  );
};

/* eslint-disable react/forbid-prop-types */
Form.propTypes = {
  method: PropTypes.string.isRequired,
  themeColor: PropTypes.string,
  formInputs: PropTypes.shape({
    displacement: PropTypes.object,
    caliper: PropTypes.object,
  }).isRequired,
  handleInputChange: PropTypes.func.isRequired,
  onCalculate: PropTypes.func.isRequired,
};
/* eslint-enable react/forbid-prop-types */

Form.defaultProps = {
  themeColor: '#336c40',
};

export default Form;
